import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import AnimatedSection from "../common/AnimatedSection";
import SectionHeading from "../common/SectionHeading";

const NAVY = "#1B1F3B"; const CORAL = "#FF6B6B"; const YELLOW = "#FFD93D"; const TEAL = "#06D6A0"; const PURPLE = "#845EF7"; const ORANGE = "#FF9F1C";

const ICONS = ["🌟", "💡", "🎨", "🛡️", "🤝", "🚀"];
const COLORS = [TEAL, CORAL, PURPLE, YELLOW, ORANGE, "#74C0FC"];

const WhyChooseSection = ({ cards }) => (
  <AnimatedSection sx={{ backgroundColor: YELLOW, py: { xs: 9, md: 12 }, position: "relative", overflow: "hidden" }}>
    {/* Decorative corners */}
    <Box sx={{ position: "absolute", top: -30, left: -30, width: 120, height: 120, borderRadius: "50%", backgroundColor: CORAL, border: `3px solid ${NAVY}`, opacity: 0.6 }} />
    <Box sx={{ position: "absolute", bottom: -40, right: -40, width: 160, height: 160, borderRadius: "50%", backgroundColor: TEAL, border: `3px solid ${NAVY}`, opacity: 0.5 }} />

    <Container maxWidth="xl" sx={{ position: "relative" }}>
      <SectionHeading
        eyebrow="Why Choose Us"
        title="Why Families Choose St Lords 💛"
        description="A school where children can learn, enjoy, explore and grow."
        align="center"
        eyebrowColor={NAVY}
        eyebrowBg="rgba(27,31,59,0.12)"
      />

      <Grid container spacing={3}>
        {cards.map((card, i) => (
          <Grid item xs={12} sm={6} md={4} key={i}>
            <Box
              sx={{
                p: 3.5,
                borderRadius: "16px",
                backgroundColor: "#fff",
                border: `2.5px solid ${NAVY}`,
                boxShadow: `5px 5px 0 ${NAVY}`,
                height: "100%",
                transition: "all 0.2s ease",
                "&:hover": { transform: "translate(-3px,-3px)", boxShadow: `8px 8px 0 ${NAVY}` },
              }}
            >
              <Box
                sx={{
                  width: 52, height: 52, borderRadius: "12px",
                  backgroundColor: COLORS[i % COLORS.length],
                  border: `2px solid ${NAVY}`,
                  display: "grid", placeItems: "center",
                  fontSize: "1.5rem", mb: 2,
                  animation: `wiggle ${2.5 + i * 0.3}s ease-in-out infinite`,
                }}
              >
                {ICONS[i]}
              </Box>
              <Typography variant="h5" sx={{ fontFamily: "'Fredoka One', cursive", fontSize: "1.25rem", color: NAVY, mb: 1 }}>
                {card.title}
              </Typography>
              <Typography sx={{ color: "#4A4E6D", fontWeight: 600, lineHeight: 1.7, fontSize: "0.92rem" }}>
                {card.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Container>
  </AnimatedSection>
);

export default WhyChooseSection;
